import styled from 'styled-components';

import { colors } from 'global/colors';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 5px 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: relative;
`;

export const Title = styled.span`
  text-transform: uppercase;
  color: ${colors.lightGray2};
  font-size: 14px;
  font-weight: bold;
`;

export const Hr = styled.hr`
  border: 0;
  height: 1px;
  background: ${colors.lightGray2};
  width: 100%;
  margin: 0 0 2px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeadingButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: baseline;
  gap: 5px;
  margin-right: 5px;
`;
